/**
 * @file 受限运行期：新建/演化入口的禁用提示
 * @author sunyingying01
 */

import React from 'react';
import {Tooltip} from 'antd';
import type {TooltipPlacement} from 'antd/es/tooltip';

import {goToNewPlatform} from '@/utils/migration';
import {GO_TO_NEW_PLATFORM, RESTRICT_TIP} from '../constants';
import styles from './index.module.less';

interface MigrationRestrictTipProps {
    /** 是否处于受限运行期，false 时原样渲染 children */
    enabled: boolean;
    placement?: TooltipPlacement;
    children: React.ReactElement;
}

const MigrationRestrictTip: React.FC<MigrationRestrictTipProps> = ({
    enabled, placement = 'right', children
}) => {
    if (!enabled) {
        return children;
    }

    return (
        <Tooltip
            color="#000"
            placement={placement}
            classNames={{root: styles.restrictTooltip}}
            title={(
                <span className={styles.tipContent}>
                    {RESTRICT_TIP}
                    <span
                        className={styles.link}
                        role="button"
                        tabIndex={0}
                        onClick={goToNewPlatform}
                        onKeyDown={e => e.key === 'Enter' && goToNewPlatform()}
                    >
                        {GO_TO_NEW_PLATFORM}
                    </span>
                </span>
            )}
        >
            {children}
        </Tooltip>
    );
};

export default MigrationRestrictTip;
